import { css } from '@emotion/core';
import tokens from '../../utils/current-theme-tokens';
import animations from './animations';
import fontFace from './font';
import normalize from './normalize';
import vars from '../../current-theme-variables';
import { fontBase } from '../typography/typography-scale';
/* stylelint-disable property-no-vendor-prefix */

var globalStyles = /*#__PURE__*/css(fontFace, ";", normalize, ";html{box-sizing:border-box;}*,*::before,*::after{box-sizing:inherit;}body{", fontBase, ";font-family:", vars.font.bodyFontFamily, ";color:", tokens.colors.neutral.heavy.default, ";-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-size-adjust:100%;-webkit-text-size-adjust:100%;}", animations);
export default globalStyles;